import React, { Component } from "react";
import { connect } from "react-redux";
import NavLogo from "../Navigation/NavLogo/index";
import NavLeft from "./NavLeft";
import NavRight from "./NavRight";
import Aux from "../../../../hoc/_Aux";
import DEMO from "../../../../store/constant";
import * as actionTypes from "../../../../store/actions";

import logo from "../../../../assets/images/logo/logo-main-light.svg";

class NavBar extends Component {
  render() {
    let headerClass = [
      "navbar",
      "pcoded-header",
      "navbar-expand-lg",
      this.props.headerBackColor,
    ];

    // headerFixedLayout: false, // not available in lite version
    // headerFixedLayout 있다면 let headerClass에 "headerpos-fixed" 추가
    if (this.props.headerFixedLayout) {
      headerClass = [...headerClass, "headerpos-fixed"];
    }

    // collapseMenu 있다면 let toggleClass에 "on"추가
    let toggleClass = ["mobile-menu"];
    if (this.props.collapseMenu) {
      toggleClass = [...toggleClass, "on"];
    }

    return (
      <Aux>
        <header className={headerClass.join(" ")}>
          {/* <div className="m-header">
            <a
              className={toggleClass.join(" ")}
              id="mobile-collapse1"
              href={DEMO.BLANK_LINK}
              onClick={this.props.onToggleNavigation}
            >
              <span />
            </a>
            <a href={DEMO.BLANK_LINK} className="b-brand">
              <div>
                <img
                  className="mobile-angkor-logo"
                  src={logo}
                  alt="angkor chat"
                />
              </div>
              <div className="b-bg">
                <i className="feather icon-trending-up" />
              </div>
              <span className="b-title">Datta Able</span>
            </a>
          </div> */}
          {/* <a className="mobile-menu" id="mobile-header" href={DEMO.BLANK_LINK}>
            <i className="feather icon-more-horizontal" />
          </a> */}{" "}
          <NavLogo
            collapseMenu={this.props.collapseMenu}
            windowWidth={this.props.windowWidth}
            onToggleNavigation={this.props.onToggleNavigation}
          />
          <div className="collapse navbar-collapse">
            <NavLeft />
            <NavRight rtlLayout={this.props.rtlLayout} />
          </div>
        </header>
      </Aux>
    );
  }
}

// const mapStateToProps = (state) => {
//   return {
//     rtlLayout: state.rtlLayout,
//     headerBackColor: state.headerBackColor,
//     headerFixedLayout: state.headerFixedLayout,
//     collapseMenu: state.collapseMenu,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     onToggleNavigation: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
//   };
// };

//export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
export default NavBar;
